import { Button, Collapse, MenuItem, Select, Switch } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { useMemo, useEffect, useReducer, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterFuntion, useSchemeSearch } from '../../../../hooks/useSchemeData';
import { favLogos, logo } from '../../../../logo/logos';
import en from '../../../../lang/en-us';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import SearchInput, { SchemeSearchInput } from '../../../../lib/SearchInput';
import { getMasterData } from '../../../../redux-store/actions/newPurchase';
import { RootStateType } from '../../../../redux-store/reducers';
import { SwipeableDrawer } from '@material-ui/core';
import { _debounce } from '../../../../utils/utilityFunctions';
import { AutoSizer, InfiniteLoader, List } from 'react-virtualized';
import {
    Filter,
    FilterKeys,
    FundFiltersTypes,
    Id,
    MFFilterBoxProps,
    MinimunInvestMentTypes,
    ReturnPeriods,
    ReturnsTimeLines,
} from './types';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { SchemeListCardSkelton } from '../../../../skeltons/NewPurchase';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { CommercialRootPath } from '../routeConfig';
import { PlanTypes } from '../../../../redux-store/types/portfolio';
import SelectInput from '@material-ui/core/Select/SelectInput';
import { time } from 'console';

const { dbCommercial } = en;

export const getSubcategory = (subcategoryName: string = '') =>
    subcategoryName.split(': ')[1] || '';

export const MutualFundBox = ({ history, image, fund, year, isinCode }: MFFilterBoxProps) => {
    const { schemeName, schemeCategory, schemeSubCategory, returns } = fund;
    const categories = [schemeCategory, getSubcategory(schemeSubCategory)];
    const profit = parseFloat(Number(returns[year]).toFixed(2)) || NaN;
    return (
        <a
            style={{ height: '90%', alignItems: 'center' }}
            className="mf-filters-info"
            onClick={() => history.push(`${isinCode}/explore`)}
        >
            <div className="logo">
                <img
                    style={{ width: '35px', height: '35px' }}
                    src={`/images/fav-logos/${image}`}
                    alt="icon"
                />
            </div>
            <div className="mf-filters-title">
                <h4>{schemeName}</h4>
                <p>
                    {categories.map((category: string) => (
                        <span key={category}> {category}</span>
                    ))}
                </p>
            </div>
            <div className="mf-filters-info-right">
                <div className="mf-filters-percent">
                    <h6 style={{ color: profit >= 0 ? '#1bc387' : 'black' }}>
                        {profit >= 0 ? '+' : ''}
                        {!!profit ? `${profit}%` : 'NA'}
                    </h6>
                    <p>{ReturnPeriods.find((time) => time.value === year)?.shortLabel} Returns</p>
                </div>
                <img className="arrow" src="/images/right-arrow.svg" alt="icon" />
            </div>
        </a>
    );
};

const initFilters: FundFiltersTypes<Filter> = {
    amcs: [],
    categories: [],
    fundSizes: [],
    risk: [],
    planMode: [],
    minimumInvestment: [],
};

function filterReducer(
    state: FundFiltersTypes<Filter>,
    action: {
        type: FilterKeys;
        payload: Filter[];
        actionType?: string;
        initState?: FundFiltersTypes<Filter>;
    },
): FundFiltersTypes<Filter> {
    const { payload, type, actionType, initState = initFilters } = action;
    switch (actionType) {
        case 'CLEAR':
        case 'CANCEL':
            const { planMode } = state;
            const { planMode: initPlanMode, ...rest } = initState;
            return { planMode, ...rest };
        default:
            return { ...state, [type]: payload };
    }
}
enum MOBILE_FILTERS {
    F = 'fund house',
    C = 'category',
    S = 'fund size',
    R = 'returns',
    P = 'plan',
    MIN_INVEST = 'minimunInvestment',
}

const PLAN_MODE_TYPES = ['Direct', 'Regular'];

export default function ExploreMFFilters(props: any) {
    const [open, setOpen] = useState<boolean>(true);
    const [category, setCategory] = useState<boolean>(!props.location.state?.categories);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [mobileFilter, setMobileFilter] = useState<string>(MOBILE_FILTERS.F);
    const [amcSearch, setAmcSearch] = useState<string | null>(null);
    const [amcNames, setAmcNames] = useState<any[]>([]);
    const [filters, setFilters] = useState<FilterFuntion[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [returnTimeLine, SetReturnTimeLine] = useState<ReturnsTimeLines>(
        ReturnsTimeLines.Three_Years,
    );
    const [filterState, dispatchFilter] = useReducer(filterReducer, {
        ...initFilters,
        ...(props.location.state || {}),
    });
    const prevFilters = useRef<FundFiltersTypes<Filter> | null>(null);

    const { exploreSchemeData, masterData } = useSelector(({ newPurchase }: RootStateType) => ({
        ...newPurchase,
    }));

    const { exploreData, nextPage } = useSchemeSearch({
        filters,
    });

    const handleClick = () => {
        setOpen(!open);
    };

    const categoryHandleClick = () => {
        setCategory(!category);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        setAmcNames(masterData.amcDetails);
    }, [masterData.amcDetails]);

    useEffect(() => {
        setData(exploreData);
    }, [exploreData]);

    useEffect(() => {
        const { amcs, categories, planMode, minimumInvestment } = filterState;
        const amcFilterFunc: FilterFuntion = ({ amc }) => {
            return !amcs.length || !!amcs.find((_amc) => _amc.value === `${amc}`);
        };
        const categoriesFunc: FilterFuntion = ({ schemeCategoryID, schemeSubCategoryID }) => {
            return (
                !categories.length ||
                !!categories.find(
                    (category) =>
                        category.value === schemeCategoryID &&
                        (!category.sub?.length ||
                            !!category.sub?.find((sub) => sub.value === schemeSubCategoryID)),
                )
            );
        };
        const planModeFunc: FilterFuntion = ({ plan }) => {
            return (
                !planMode.length ||
                !!planMode.find((_plan) =>
                    _plan.value === PlanTypes.Direct
                        ? [PlanTypes.D, PlanTypes.Direct].includes(plan.toUpperCase())
                        : [PlanTypes.R, PlanTypes.Reggular].includes(plan.toUpperCase()),
                )
            );
        };
        const minimunInvestmentFunc: FilterFuntion = ({ minAmountLumpsum, minAmountSIP }) => {
            const minLumpsum = isNaN(minAmountLumpsum) ? 0 : Number(minAmountLumpsum);
            const minSIP = isNaN(minAmountSIP) ? 0 : Number(minAmountSIP);
            return (
                !minimumInvestment.length ||
                !!minimumInvestment.some((investmentAmount) => {
                    if (investmentAmount.value === MinimunInvestMentTypes.LESS_THAN_FIVE_HUNDRED) {
                        return minLumpsum <= 500;
                    }
                    if (
                        investmentAmount.value ===
                        MinimunInvestMentTypes.FIVE_HUNDRED_TO_TWO_THOUSAND
                    ) {
                        return minLumpsum >= 501 && minLumpsum <= 2000;
                    }
                    if (
                        investmentAmount.value === MinimunInvestMentTypes.GREATER_THAN_TWO_THOUSAND
                    ) {
                        return minLumpsum > 2000;
                    }
                })
            );
        };
        setFilters([amcFilterFunc, categoriesFunc, planModeFunc, minimunInvestmentFunc]);
    }, [filterState]);

    const doAmcSearch = (e: any) => {
        if (!e.target.value) {
            setAmcNames(masterData?.amcDetails);
            return;
        }
        const key = e.target.value.toLowerCase();
        setAmcNames(() =>
            masterData?.amcDetails?.filter((ele: any) =>
                ele.amcFullName?.toLowerCase()?.includes(key),
            ),
        );
    };

    const handleFilterChange = (filter: Filter, type: FilterKeys) => (): void => {
        const payload = filterItems(filterState[`${type}`], filter);
        dispatchFilter({ type, payload });
    };

    const handleSubFilters = (type: FilterKeys, index: number, data: Filter) => (): void => {
        let items = filterState[`${type}`];
        const _item = items[index];
        const sub = filterItems(_item.sub || [], data);
        items[index] = { ..._item, sub };
        dispatchFilter({ type, payload: [...items] });
    };

    const filterItems = (list: any[] = [], target: Filter): Filter[] => {
        const index = list.findIndex((item) => item.value === target.value);
        return index === -1
            ? [...list, target]
            : list.filter((item) => target.value !== item.value);
    };

    function isRowLoaded({ index }: any) {
        return !!data[index];
    }

    function loadMoreRows({ startIndex }: any) {
        const { value = [], done }: any = nextPage?.next(startIndex);
        return Promise.resolve(setData((prev) => [...prev, ...value]));
    }

    function rowRenderer({ key, index, style }: any) {
        const scheme: any = data[index] || {};
        return (
            <div key={key} style={{ ...style, top: style.top + 20, width: '100%' }}>
                <MutualFundBox
                    key={scheme.isinCode}
                    fund={scheme}
                    history={props.history}
                    image={scheme.fundLogo}
                    isinCode={scheme.isinCode}
                    year={returnTimeLine}
                />
            </div>
        );
    }

    const deleteFilter = (type: FilterKeys, parentId: Id, subId?: Id) => (): void => {
        let items = filterState[`${type}`];
        const parentIndex = items.findIndex((category) => category.value === parentId);
        if (subId) {
            const _item = items[parentIndex];
            const sub = _item.sub?.filter((sub) => sub.value !== subId);
            items[parentIndex] = { ..._item, sub };
            dispatchFilter({ type, payload: [...items] });
            return;
        }
        items.splice(parentIndex, 1);
        dispatchFilter({ type, payload: items });
    };

    const FilterChip = ({
        filter,
        type,
        subId,
    }: {
        filter: Filter;
        type: FilterKeys;
        subId?: Id;
    }) => {
        return (
            <a>
                {filter.name}{' '}
                <img
                    onClick={deleteFilter(type, filter.value, subId)}
                    src="/images/close-black.svg"
                    alt="icon"
                />
            </a>
        );
    };

    const renderSelectedFilters = () => {
        return (Object.keys(filterState) as Array<FilterKeys>)
            .filter((type) => type !== FilterKeys.PlanMode)
            .map((type: FilterKeys) =>
                filterState[type].map((item) =>
                    !!item.sub?.length ? (
                        item.sub.map((_sub) => (
                            <FilterChip
                                key={`${type}-${_sub.value}`}
                                filter={{ ...item, name: `${item.name} - ${_sub.name}` }}
                                type={type}
                                subId={_sub.value}
                            />
                        ))
                    ) : (
                        <FilterChip key={`${type}-${item.value}`} filter={item} type={type} />
                    ),
                ),
            );
    };

    // const FundSizeFilters = () => {
    //     return masterData.fundSizes.map(({ name, id }) => (
    //         <CheckBoxField
    //             value={!!filterState.fundSizes.find((fund) => fund.value === id)}
    //             onChange={handleFilterChange({ value: id, name }, FilterKeys.FundSizes)}
    //             key={id}
    //             label={name}
    //         />
    //     )) as any;
    // };
    const FundHouseFilters = (
        <div className="fund-house">
            <SearchInput
                id="search-amc"
                placeholder={dbCommercial.exploreMfs.searchAmc}
                darkmode={true}
                value={amcSearch}
                onChange={_debounce(doAmcSearch, 50, (e: any) => {
                    setAmcSearch(e.target.value);
                })}
            />
            <div className="fund-house-list">
                {amcNames.map((data: any) => (
                    <CheckBoxField
                        key={data.amc}
                        value={!!filterState.amcs.find((amc) => amc.value === data.amc)}
                        onChange={handleFilterChange(
                            { value: data.amc, name: data.amcFullName },
                            FilterKeys.Amc,
                        )}
                        label={data.amcFullName}
                    />
                ))}
            </div>
        </div>
    );

    const [planMode, setPlanMode] = useState<PlanTypes>(PlanTypes.Direct);

    const PlanModeObject: { [key: string]: any } = {
        [PlanTypes.Direct]: { label: 'Direct', value: PlanTypes.Direct },
        [PlanTypes.Reggular]: { label: 'Regular', value: PlanTypes.Reggular },
    };

    useEffect(() => {
        deleteFilter(
            FilterKeys.PlanMode,
            planMode === PlanTypes.Reggular ? PlanTypes.Direct : PlanTypes.Reggular,
        )();
        handleFilterChange(
            { value: PlanModeObject[planMode].value, name: PlanModeObject[planMode].label },
            FilterKeys.PlanMode,
        )();
    }, [planMode]);

    const PlanModeSwitch = (
        <div className="toggle-tabs">
            <a className={planMode === PlanTypes.Direct ? 'active' : ''}> Direct </a>
            <div className="toggle">
                <Switch
                    checked={planMode === PlanTypes.Direct ? false : true}
                    value={planMode}
                    onChange={(e) => {
                        setPlanMode(e.target.checked ? PlanTypes.Reggular : PlanTypes.Direct);
                    }}
                    name="signInToggle"
                    inputProps={{ 'aria-label': 'toggleSwitch' }}
                />
            </div>
            <a className={planMode === PlanTypes.Reggular ? '' : 'active'}> Regular </a>
        </div>
    );

    const PlanModeFilters = (
        <div className="fund-house-list">
            {[
                { label: 'Direct', value: PlanTypes.Direct },
                { label: 'Regular', value: PlanTypes.Reggular },
            ].map((plan) => (
                <CheckBoxField
                    key={plan.value}
                    value={!!filterState.planMode.find((_plan) => plan.value === _plan.value)}
                    onChange={handleFilterChange(
                        { value: plan.value, name: plan.label },
                        FilterKeys.PlanMode,
                    )}
                    label={plan.label}
                />
            ))}
        </div>
    );

    const MinimunInvestmentTypeFilter = (
        <div className="fund-house-list">
            {[
                { label: '<=₹500', value: MinimunInvestMentTypes.LESS_THAN_FIVE_HUNDRED },
                { label: '₹501-₹2000', value: MinimunInvestMentTypes.FIVE_HUNDRED_TO_TWO_THOUSAND },
                { label: '>₹2000', value: MinimunInvestMentTypes.GREATER_THAN_TWO_THOUSAND },
            ].map(({ label, value: minAmount }) => (
                <CheckBoxField
                    key={minAmount}
                    value={
                        !!filterState.minimumInvestment.find((invest) => invest.value === minAmount)
                    }
                    onChange={handleFilterChange(
                        { value: minAmount, name: label },
                        FilterKeys.MinimunInvestment,
                    )}
                    label={label}
                />
            ))}
        </div>
    );

    const CategoryFilters = () => {
        return masterData.categories.map(({ categoryId, categoryName, subcategory }) => (
            <>
                <CheckBoxField
                    value={
                        !!filterState.categories.find((category) => category.value === categoryId)
                    }
                    onChange={handleFilterChange(
                        { value: categoryId, name: categoryName },
                        FilterKeys.Categories,
                    )}
                    key={categoryId}
                    label={categoryName}
                />
                {!!filterState.categories.find((category) => category.value === categoryId) && (
                    <div className="sub-category">
                        {subcategory.map(({ subcategoryId, subcategoryName }) => {
                            const index = filterState.categories.findIndex(
                                (category) => category.value === categoryId,
                            );
                            const name = getSubcategory(subcategoryName);
                            return (
                                <CheckBoxField
                                    value={
                                        !!filterState.categories[index]?.sub?.find(
                                            (subCategory) => subCategory.value === subcategoryId,
                                        )
                                    }
                                    onChange={handleSubFilters(FilterKeys.Categories, index, {
                                        name,
                                        value: subcategoryId,
                                    })}
                                    key={categoryId + `${subcategoryName}`}
                                    label={name}
                                />
                            );
                        })}
                    </div>
                )}
            </>
        )) as any;
    };

    const RenderReturnFilter = () => {
        return (
            <Select
                style={{
                    padding: '1px',
                    fontSize: '12px',
                    width: 110,
                }}
                variant="outlined"
                onChange={({ target: { value } }) => SetReturnTimeLine(value as ReturnsTimeLines)}
                value={returnTimeLine}
            >
                {ReturnPeriods.map((time) => (
                    <MenuItem key={time.value} value={time.value}>
                        {time.label}
                    </MenuItem>
                ))}
            </Select>
        );
    };

    const renderMobileFilters = () => {
        switch (mobileFilter) {
            case MOBILE_FILTERS.F:
                return FundHouseFilters;
            case MOBILE_FILTERS.C:
                return <CategoryFilters />;
            case MOBILE_FILTERS.MIN_INVEST:
                return MinimunInvestmentTypeFilter;
            case MOBILE_FILTERS.R:
                return <RenderReturnFilter />;
            // case MOBILE_FILTERS.P:
            //     return PlanModeFilters;
            default:
                return null;
        }
    };

    const onMobileFilterOpen = () => {
        setDrawer(true);
        // hold previous filters to handle cancel
        prevFilters.current = filterState;
    };

    const onCancelFilter = () => {
        dispatchFilter({
            type: FilterKeys.Amc,
            payload: [],
            initState: !!prevFilters.current ? prevFilters.current : initFilters,
            actionType: 'CANCEL',
        });
        setDrawer((prev) => !prev);
    };

    const showFilterCount = (): string => {
        const count = (Object.keys(filterState) as Array<FilterKeys>)
            .filter((type) => type !== FilterKeys.PlanMode)
            .reduce((acc: number, curr: FilterKeys) => filterState[curr].length + acc, 0);
        return count ? `${count}` : '';
    };

    return (
        <div className="curved-bg faq-curved commercial-trans new-purchase mf-filters-outer">
            <div className="explore-mf-heading">
                <h2 className="heading">
                    <a onClick={() => props.history.goBack()}>
                        <img src="/images/left-arrow-black.svg" alt="icon" />
                    </a>
                    {dbCommercial.exploreMfs.heading}
                </h2>
                <div className="explore-mf-search">
                    <SchemeSearchInput
                        id="search-mfs"
                        placeholder={dbCommercial.exploreMfs.searchmf}
                        darkmode={true}
                        options={exploreData}
                    />
                </div>
            </div>
            <div className="plan_mode_switch">
                <div className="mobile_mode">
                    {PlanModeSwitch}
                </div>
                <div className="explore-mf-filter-mobile mobile_mode">
                    <a onClick={onMobileFilterOpen}>
                        <img src="/images/filters.svg" alt="icon" />
                        {dbCommercial.exploreMfs.filter}-{showFilterCount()}
                    </a>
                </div>
            </div>
            <div className="curved-bg-content explore-mf-filters">
                <div className="faq-content-outer">
                    <div className="faq-content-left desktop_mode">
                        {PlanModeSwitch}
                        <div className="filters-top">
                            <h5>
                                <img src="/images/filters.svg" alt="icon" />
                                {dbCommercial.exploreMfs.filters}
                            </h5>
                            <a
                                onClick={() => {
                                    dispatchFilter({
                                        type: FilterKeys.Amc,
                                        payload: [],
                                        actionType: 'CLEAR',
                                    });
                                    setDrawer(false);
                                }}
                            >
                                {dbCommercial.exploreMfs.clearAll}
                            </a>
                        </div>
                        <div className="fund-returns">
                            <h4>{dbCommercial.exploreMfs.returnDuration}</h4>
                            <RenderReturnFilter />
                        </div>
                        <div className="fund-min-invest">
                            <h4>{dbCommercial.exploreMfs.minimumInvestmentFilterTitle}</h4>
                            {MinimunInvestmentTypeFilter}
                        </div>
                        <div className="fund-house">
                            <h4 onClick={handleClick}>
                                {dbCommercial.exploreMfs.fundHouse}
                                {open ? <ExpandLess /> : <ExpandMore />}
                            </h4>
                            <Collapse in={open} unmountOnExit>
                                {FundHouseFilters}
                            </Collapse>
                        </div>
                        <div className="category">
                            <h4 onClick={categoryHandleClick}>
                                {dbCommercial.exploreMfs.category}
                                {category ? <ExpandLess /> : <ExpandMore />}
                            </h4>
                            <Collapse in={category} unmountOnExit>
                                <CategoryFilters />
                            </Collapse>
                        </div>

                        {/* <div className="risk">
                            <h4>{dbCommercial.exploreMfs.risk}</h4>
                            <RiskFilters />
                        </div> */}
                        {/* <div className="investment-type">
                            <h4>{dbCommercial.exploreMfs.investmentType}</h4>
                            <CheckBoxField label={dbCommercial.exploreMfs.onlySip} />
                            <CheckBoxField label={dbCommercial.exploreMfs.onlyLumpsum} />
                        </div> */}
                    </div>
                    <div className="faq-content-right">
                        <div className="faq-content-right-content">
                            <div className="new-purchase-right">
                                <div className="mf-selected-filters desktop_mode">
                                    <h5>{dbCommercial.exploreMfs.selectedFilters}:</h5>
                                    <div className="selected-filters-tags">
                                        {renderSelectedFilters()}
                                    </div>
                                </div>
                                <div className="mf-filters-total">
                                    {(Object.keys(filterState) as Array<FilterKeys>).some(
                                        (key) => !!filterState[`${key}`].length,
                                    ) &&
                                        !data.length &&
                                        !!exploreSchemeData.length ? (
                                        <NoFoliosFound info={en.common.noRecordsFound} />
                                    ) : (
                                        <AsyncLoader
                                            skelton={
                                                <div className="list-cards">
                                                    <SchemeListCardSkelton />
                                                </div>
                                            }
                                            data={exploreSchemeData.length ? true : null}
                                        >
                                            <InfiniteLoader
                                                isRowLoaded={isRowLoaded}
                                                loadMoreRows={loadMoreRows}
                                                rowCount={exploreSchemeData.length}
                                            >
                                                {({ onRowsRendered, registerChild }) => (
                                                    <AutoSizer disableHeight>
                                                        {({ width }) => (
                                                            <List
                                                                height={window.innerHeight - 190}
                                                                onRowsRendered={onRowsRendered}
                                                                ref={registerChild}
                                                                rowCount={data.length}
                                                                rowHeight={120}
                                                                rowRenderer={rowRenderer}
                                                                width={width}
                                                            />
                                                        )}
                                                    </AutoSizer>
                                                )}
                                            </InfiniteLoader>
                                        </AsyncLoader>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className="source-footer">
                <img src="/images/source-icon.svg" alt="icon" />
                <span> {dbCommercial.newPurchase.vrFooterSource}</span>
                {dbCommercial.newPurchase.vrFooterInfo}
            </p>
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.exploreMfs.filters}
                        </h5>
                        <a
                            onClick={() => {
                                dispatchFilter({
                                    type: FilterKeys.Amc,
                                    payload: [],
                                    actionType: 'CLEAR',
                                });
                            }}
                        >
                            {dbCommercial.exploreMfs.clearAll}
                        </a>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="filters-drawer-content-left">
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.F)}>
                                {dbCommercial.exploreMfs.fundHouse}
                            </a>
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.C)}>
                                {dbCommercial.exploreMfs.category}
                            </a>
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.MIN_INVEST)}>
                                {dbCommercial.exploreMfs.minimumInvestmentFilterTitle}
                            </a>
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.R)}>
                                {dbCommercial.exploreMfs.returnDuration}
                            </a>
                        </div>
                        <div className="filters-drawer-content-right">{renderMobileFilters()}</div>
                    </div>
                    <div className="filters-drawer-bottom">
                        <div className="btns">
                            <Button className="customBtn cancelBtn" onClick={onCancelFilter}>
                                Cancel
                            </Button>
                            <Button className="customBtn" onClick={() => setDrawer(false)}>
                                Apply
                            </Button>
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
}
